import { todayISO } from "@/utils/format";

const KEY = "bgr_unlock";

const memberId = () => {
  try { return JSON.parse(localStorage.getItem("bgr_member") || "null")?.id || ""; } catch { return ""; }
};

function read() {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || "{}");
    if (d.date === todayISO() && d.member === memberId()) return { tokens: {}, pending: {}, ...d };
  } catch { /* reset */ }
  return { date: todayISO(), member: memberId(), tokens: {}, pending: {} };
}

function write(d) {
  localStorage.setItem(KEY, JSON.stringify({ ...d, date: todayISO(), member: memberId() }));
  window.dispatchEvent(new Event("bgr-unlock"));
}

export const unlockStore = {
  tokens: () => Object.values(read().tokens),
  pendingIds: () => Object.values(read().pending),
  isPending: (cid) => !!read().pending[cid],
  apply(req) {
    const d = read();
    if (req.status === "approved" && req.token) {
      d.tokens[req.category_id] = req.token;
      delete d.pending[req.category_id];
    } else if (req.status === "pending" || req.status === "expired") {
      d.pending[req.category_id] = req.id;
    } else {
      delete d.pending[req.category_id];
    }
    write(d);
  },
};

const MKEY = "bgr_member";
export const memberStore = {
  get: () => { try { return JSON.parse(localStorage.getItem(MKEY) || "null"); } catch { return null; } },
  set: (m) => { localStorage.setItem(MKEY, JSON.stringify(m)); window.dispatchEvent(new Event("bgr-member")); },
  clear: () => { localStorage.removeItem(MKEY); window.dispatchEvent(new Event("bgr-member")); },
};
